import { useMemo } from "react";

import { NotificationRow } from "@/components/doc/left-sidebar/top-menu/notifications/NotificationRow";
import { NotificationText } from "@/components/doc/left-sidebar/top-menu/notifications/NotificationText";
import { useStore } from "@/store";
import { useChats } from "@/store/useChats";
import { docPageUrl } from "@/urls";
import { extractMessageBodyText } from "@/utils/extractMessageBodyText";

import type { Mention, Notification } from "@/api";

export function MentionNotificationItem({
  notification,
  entity,
}: {
  notification: Notification;
  entity: Mention;
}) {
  const { document, body, sourceType, chatUid, messageUid } = entity;

  const store = useStore();
  const chats = useChats();

  const preview = useMemo(() => extractMessageBodyText(body), [body]);

  const href = document
    ? docPageUrl({
        docId: document.uid,
        teamPermalink: document.teamPermalink ?? undefined,
        chat: chatUid ?? undefined,
        message: messageUid ?? undefined,
      })
    : undefined;

  const openInPlace = () => {
    if (!document || !chatUid || store.doc?.id !== document.uid) return false;
    void chats.openChatByUid(chatUid, messageUid ?? undefined);
    return true;
  };

  // Only chat mentions notify so far.
  if (sourceType !== "Message") return null;

  return (
    <NotificationRow
      notification={notification}
      eventType="mention"
      badge="mention"
      href={href}
      onNavigate={openInPlace}
    >
      <NotificationText
        notification={notification}
        docId={document?.uid}
        docTitle={document?.title}
        chatUid={chatUid}
        messageUid={messageUid}
        copyKey="mention.comment"
      />
      {preview && (
        <p className="font-geist text-[16px] leading-[20px] tracking-[-0.02em] line-clamp-2">
          {preview}
        </p>
      )}
    </NotificationRow>
  );
}
